import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";

import { Button } from "ui/button";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { IApproveBusinessSectionModalProps } from "./types";

export const ApproveBusinessSectionModal = (
  props: IApproveBusinessSectionModalProps
) => {
  const {
    isOpen,
    setIsOpen,
    handleToggleApprovalSectionModal,
    handleApproveBusinessSection,
    isLoading,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        height: "316px",
      }}
      allowOutsideClick={false}
    >
      <ModalHeader modalType="approval" />
      <Box className="flex flex-col gap-5">
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#1A202C"
          >
            Approve This Section
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
        </Box>
        <Box
          css={{
            backgroundColor: "#FEF5E7",
            border: "1px solid #FFEFD8",
            height: "64px",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "12px",
          }}
        >
          <Box
            css={{
              width: "16px",
              height: "16px",
              flexBasis: "16px",
              flexShrink: "0",
            }}
          >
            <InfoOutlineIcon className="w-full h-auto" />
          </Box>
          <Paragraph3
            lineHeight="20px"
            textColor="#1A202C"
          >
            Please ensure you have reviewed this section before approving it.
          </Paragraph3>
        </Box>
        <Box
          css={{
            height: "44px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            variant="outline"
            textColor="#344054"
            border="1px solid #D0D5DD"
            className="w-[170px]"
            onClick={handleToggleApprovalSectionModal}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="solid"
            textColor="#ffffff"
            border="1px solid #00535C"
            className="w-[170px]"
            onClick={handleApproveBusinessSection}
            loading={isLoading}
            loadingText="Approving..."
            disabled={isLoading}
          >
            Approve Section
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
